import React from 'react';

import { flagStyles } from '../settings';

const SvgLT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3144px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLT;
